import { createSelector } from '@reduxjs/toolkit'
import camelcaseKeys from 'camelcase-keys'
import { RootState } from 'lib/core/data/reducer'
import { Slice, PaymentToken } from './types'

export const getSlice = (state: RootState): Slice => {
  return state.customer.paymentTokens
}

interface CreditCardDetails {
  [key: string]: any
}

export const getPaymentTokens = (paymentMethodCode?: string) => createSelector(
  getSlice,
  slice => {
    const items: PaymentToken[] = []

    slice.payload?.items.forEach(item => {
      let cardDetailsData: CreditCardDetails = {}

      try {
        cardDetailsData = camelcaseKeys(JSON.parse(item.details ?? '{}')) as CreditCardDetails
      } catch {
        // TODO: report error
      }

      const paymentToken: PaymentToken = {
        details: cardDetailsData,
        paymentMethodCode: item.payment_method_code,
        publicHash: item.public_hash,
        type: item.type
      }

      const paymentMethodCodeFilter = !paymentMethodCode ||
        (paymentMethodCode && paymentMethodCode === paymentToken.paymentMethodCode)

      if (paymentMethodCodeFilter) {
        items.push(paymentToken)
      }
    })

    return items
  }
)
